import type { IrsApiContract, RegisterPackCodeApiResponse, RegisterPackCodeResponse } from "@jti/rest-api-types";

import { Rest } from "../../Rest";

/** @deprecated Legacy proxy implementation — superseded by EVO. To be deleted after production verification. */
export class IrsApiLegacy extends Rest implements IrsApiContract {
  constructor(
    baseUrl: string,
    protected tenantToken: string,
    protected ciamToken: string
  ) {
    super(baseUrl);
    this.setCommonHeader("X-DES-AK-TENANT-TOKEN", this.tenantToken);
    this.setCommonHeader("X-DES-CONSUMER-IAM-TOKEN", this.ciamToken);
  }

  async registerPackCode(code: string): Promise<RegisterPackCodeResponse> {
    try {
      const response = await this.request<RegisterPackCodeApiResponse>(
        "/me/products/register",
        {
          method: "POST",
          body: JSON.stringify({
            code,
          }),
          headers: {
            "X-DES-CONSUMER-IAM-TOKEN": this.ciamToken,
            "X-DES-AK-TENANT-TOKEN": this.tenantToken,
          },
        },
        true
      );

      const hasInventory = !!response.inventory;

      return {
        hasError: false,
        isValid: hasInventory,
        limitReached: response.is_genuine && response.is_registrable && !hasInventory,
        loyalty_rule: response.loyalty_rule,
      };
    } catch (error: any) {
      const limitReached = error?.is_genuine && error?.is_registrable && !error.inventory;

      return {
        hasError: true,
        limitReached: limitReached || false,
        isValid: false,
        loyalty_rule: null,
        errorCode: error.error_code,
      };
    }
  }
}
